import { render, staticRenderFns } from "./_ProductTabs.vue?vue&type=template&id=0892a9aa"
import script from "./_ProductTabs.vue?vue&type=script&lang=js"
export * from "./_ProductTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports